import { useState } from "react";
import Icon from "../../components/AppIcon";

const LazyYouTube = ({ videoId, title }) => {
    const [play, setPlay] = useState(false);

    if (play) {
        return (
            <iframe
                className="w-full h-full"
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        );
    }

    return (
        <button
            onClick={() => setPlay(true)}
            className="relative w-full h-full group"
        >
            <img
                src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                alt={title}
                className="w-full h-full object-cover"
                loading="lazy"
            />

            {/* Overlay */}
            <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition">
                    <Icon name="Play" size={28} className="text-primary ml-1" />
                </div>
            </div>
        </button>
    );
};

export default LazyYouTube;
